import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class guiaRemisionService {
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarEstado() {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/estado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }


    async importarPorId(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/importar?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    
    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/importar-registrados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket50(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async xml(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cdr(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-remision/cdr?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async enviarCorreo(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-remision/enviar-correo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/guia-remision`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-remision`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async emitir(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-remision/emitir`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-remision/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-remision/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new guiaRemisionService();